// extracted by mini-css-extract-plugin
export default {"card-header-platform":"-li8x52A3A+Mpd8EKydaqQ==","card-header-carbon-ethics":"NI-BJgwD-6k5w5dUjWd2Vw=="};